"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var core_1 = require("@angular/core");
var sis_control_with_settings_base_1 = require("../control-settings/sis-control-with-settings-base");
var controls_translation_service_1 = require("../shared/controls-translation.service");
var material_1 = require("@angular/material");
var multilingual_interfaces_1 = require("./model/multilingual-interfaces");
var MultilingualComponent = /** @class */ (function (_super) {
    __extends(MultilingualComponent, _super);
    function MultilingualComponent(translationService, changeDetectorRef) {
        var _this = _super.call(this) || this;
        _this.translationService = translationService;
        _this.changeDetectorRef = changeDetectorRef;
        /**
         * The state of multilingual component (enabled or disabled).
         * @type {boolean}
         */
        _this.isDisabled = false;
        /**
         * Indicates whether the field is required or not. Used for required asterisk displaying in mat-menu.
         * @type {boolean}
         */
        _this.isRequired = false;
        /**
         * Show/hide characters count.
         * @type {boolean}
         */
        _this.showCharactersCount = false;
        /**
         * Show/hide validations. Will indicate that fields are required for empty language inputs.
         * @type {boolean}
         */
        _this.showValidations = false;
        /**
         * Indicates whether the copy panel is open for any language in the menu.
         * @type {boolean}
         */
        _this.isCopyPanelOpen = false;
        /**
         * Array of languages kept internally to manipulate the language ordering based on possible currentLanguageId changes, while having the system order.
         */
        _this._languagesArray = [];
        /**
         * The multi-lingual text that is rendered in control. This value is passed as ngModel.
         * @type {MultilingualString}
         * @private
         */
        _this._multilingualString = null;
        _this.width = 340;
        return _this;
    }
    Object.defineProperty(MultilingualComponent.prototype, "validations", {
        /**
         * Validations from the form. Used to determine when to show language input validation messages (mainly for dynamic forms).
         * @type {any}
         */
        set: function (value) {
            this.showValidations = value && value.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    MultilingualComponent.prototype.ngOnInit = function () {
        this._primaryLanguageId = this.currentLanguageId || this.defaultLanguageId;
        !this.languages && (this.languages = []);
        if (!this._multilingualString) {
            var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
            for (var _i = 0, _a = this.languages; _i < _a.length; _i++) {
                var language = _a[_i];
                multilingualStringBuilder.withValueForLanguage(language.getId(), null);
            }
            this._multilingualString = multilingualStringBuilder.build();
        }
        this.initLanguages();
    };
    /**
     * @inheritDoc
     */
    MultilingualComponent.prototype.ngOnChanges = function (changes) {
        var languagesChanged = changes["languages"];
        var currentLanguageIdChanged = changes["currentLanguageId"];
        var hintChanged = changes["hint"];
        var characterCountSettingsChanged = changes["characterCountSettings"];
        if (languagesChanged) {
            this.initLanguages();
        }
        if (currentLanguageIdChanged) {
            this._primaryLanguageId = this.currentLanguageId;
            this.initLanguages();
            this.hintText = this.hint && this.currentLanguageId && this.hint.getValue(this.currentLanguageId);
        }
        if (hintChanged) {
            this.hintText = this.hint && this._primaryLanguageId && this.hint.getValue(this._primaryLanguageId);
        }
        if (characterCountSettingsChanged) {
            this.showCharactersCount = this.characterCountSettings && this.characterCountSettings.showCharacterCount;
        }
    };
    /**
     * Rearranges the languages to have the primary language be the fist element for the view and logical implementation.
     */
    MultilingualComponent.prototype.initLanguages = function () {
        var _this = this;
        this._languagesArray = this.languages ? this.languages.slice() : [];
        var currentLanguage = this.currentLanguageId ? this._languagesArray.find(function (lang) { return lang.getId() === _this.currentLanguageId; }) : null;
        var defaultLanguage = this.defaultLanguageId ? this._languagesArray.find((function (lang) { return lang.getId() === _this.defaultLanguageId; })) : null;
        defaultLanguage && this.moveLanguageToFront(defaultLanguage);
        currentLanguage && this.moveLanguageToFront(currentLanguage);
        this.initLanguageOptions();
    };
    MultilingualComponent.prototype.moveLanguageToFront = function (lang) {
        this._languagesArray.splice(this._languagesArray.indexOf(lang), 1);
        this._languagesArray.unshift(lang);
    };
    /**
     * ControlValueAccessor interface function. This function is used to catch the changes that happen in ngModel field.
     * @param multilingualString
     */
    MultilingualComponent.prototype.writeValue = function (multilingualString) {
        if (multilingualString !== null && multilingualString !== undefined) {
            this._multilingualString = multilingualString;
            this.changeDetectorRef.detectChanges();
        }
    };
    /**
     * ControlValueAccessor interface function.
     */
    MultilingualComponent.prototype.registerOnChange = function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * ControlValueAccessor interface function.
     */
    MultilingualComponent.prototype.registerOnTouched = function (fn) {
        this._onTouchedCallback = fn;
    };
    /**
     * Returns direction of the language: LTR or RTL
     */
    MultilingualComponent.prototype.getLanguageDirection = function (languageId) {
        if (this.languages !== undefined) {
            for (var _i = 0, _a = this.languages; _i < _a.length; _i++) {
                var language = _a[_i];
                if (language.getId() === languageId) {
                    return (language.getDirection() === idm_crosscutting_concepts_frontend_1.LanguageDirection.RTL ? "rtl" : "ltr");
                }
            }
        }
    };
    /**
     * Initiates the start of editing mode of multilingual component. This function is called when the main input area is clicked.
     */
    MultilingualComponent.prototype.onFormClicked = function () {
        if (this.languages && this.languages.length > 1) {
            this.menuTrigger.openMenu();
            this.initLanguageOptions();
            this.width = this.form.nativeElement.offsetWidth;
            if (this.width < 104) {
                this.width = 104; //Min width
            }
            this.inputs.first && this.inputs.first.nativeElement.focus();
            if (this.ngTextarea && this.inputs.first) {
                var areaHeight = this.ngTextarea.nativeElement.offsetHeight;
                this.inputs.first.nativeElement.style.height = areaHeight + 'px';
            }
        }
    };
    /**
     * Sets/resets the languageOptions with component's languages' necessary properties and their corresponding text values from the multilingual string.
     */
    MultilingualComponent.prototype.initLanguageOptions = function () {
        var _this = this;
        this.languageOptions = this._languagesArray.map(function (language) {
            var direction = (language.getDirection() === idm_crosscutting_concepts_frontend_1.LanguageDirection.RTL ? "rtl" : "ltr");
            var languageValue = _this._multilingualString ? _this._multilingualString.getValue(language.getId()) : null;
            return new multilingual_interfaces_1.LanguageOption(language.getId(), language.getAcronym(), direction, languageValue);
        });
    };
    /**
     * Changes the selected language. This function is called when one of the language text areas is clicked.
     * @param language
     */
    MultilingualComponent.prototype.onSelectedLangChange = function (language) {
        this.selectedLanguage = language;
    };
    MultilingualComponent.prototype.onDone = function () {
        this.menuTrigger.closeMenu();
        this.onApplyChanges();
    };
    MultilingualComponent.prototype.onApplyChanges = function () {
        if (!this._multilingualString || this.haveValuesChanged()) {
            var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
            for (var _i = 0, _a = this.languageOptions; _i < _a.length; _i++) {
                var language = _a[_i];
                multilingualStringBuilder.withValueForLanguage(language.id, (!!language.value ? language.value.trim() : null));
            }
            this._multilingualString = multilingualStringBuilder.build();
            this._onChangeCallback && this._onChangeCallback(this._multilingualString);
        }
    };
    MultilingualComponent.prototype.haveValuesChanged = function () {
        var _this = this;
        var isChanged = false;
        this.languageOptions.forEach(function (value) {
            isChanged = isChanged || value.value !== _this._multilingualString.getValue(value.id);
        });
        return isChanged;
    };
    MultilingualComponent.prototype.isFieldInvalid = function () {
        return this.isRequired && this.showValidations && this.languageOptions.some(this.isInputInvalid.bind(this));
    };
    MultilingualComponent.prototype.isInputInvalid = function (language) {
        return this.isRequired && this.showValidations && (language.value || '').trim().length === 0;
    };
    Object.defineProperty(MultilingualComponent.prototype, "primaryLanguageId", {
        get: function () {
            return this._primaryLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultilingualComponent.prototype, "multilingualString", {
        get: function () {
            return this._multilingualString;
        },
        enumerable: true,
        configurable: true
    });
    MultilingualComponent.prototype.setMultilingualString = function (value) {
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        multilingualStringBuilder.withValueForLanguage(this._primaryLanguageId, value);
        this._multilingualString = multilingualStringBuilder.build();
        this._onChangeCallback && this._onChangeCallback(this._multilingualString);
    };
    MultilingualComponent.prototype.getMessage = function (key) {
        return this.translationService && this.translationService.getMessage(key);
    };
    MultilingualComponent.prototype.trackByLanguage = function (index, language) {
        return language.id;
    };
    MultilingualComponent.prototype.onCopyIconClicked = function (targetLanguage, index) {
        this.selectedLanguage = targetLanguage;
        if (this.languageOptions.length > 2) {
            this.copyPanelTriggers.toArray()[index].openMenu();
            this.isCopyPanelOpen = true;
        }
        else {
            this.languageOptions.forEach(function (lang) {
                if (lang != targetLanguage) {
                    lang.value = targetLanguage.value;
                }
            });
        }
    };
    MultilingualComponent.prototype.onApplyCopy = function (copyLanguageIds) {
        var _this = this;
        copyLanguageIds.forEach(function (id) {
            var languageOption = _this.languageOptions.find(function (option) { return option.id === id; });
            languageOption && (languageOption.value = _this.selectedLanguage.value);
        });
        var index = this.languageOptions.indexOf(this.selectedLanguage);
        this.isCopyPanelOpen = false;
        this.copyPanelTriggers.toArray()[index].closeMenu();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MultilingualComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], MultilingualComponent.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MultilingualComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MultilingualComponent.prototype, "defaultLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], MultilingualComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MultilingualComponent.prototype, "titleText", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MultilingualComponent.prototype, "placeholder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MultilingualComponent.prototype, "maxLength", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], MultilingualComponent.prototype, "isDisabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MultilingualComponent.prototype, "hintText", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], MultilingualComponent.prototype, "isRequired", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], MultilingualComponent.prototype, "showCharactersCount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], MultilingualComponent.prototype, "showValidations", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], MultilingualComponent.prototype, "validations", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MultilingualComponent.prototype, "width", void 0);
    __decorate([
        core_1.ViewChild('form'),
        __metadata("design:type", core_1.ElementRef)
    ], MultilingualComponent.prototype, "form", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatMenuTrigger),
        __metadata("design:type", material_1.MatMenuTrigger)
    ], MultilingualComponent.prototype, "menuTrigger", void 0);
    __decorate([
        core_1.ViewChildren('copyIcon', { read: material_1.MatMenuTrigger }),
        __metadata("design:type", core_1.QueryList)
    ], MultilingualComponent.prototype, "copyPanelTriggers", void 0);
    __decorate([
        core_1.ViewChildren('input'),
        __metadata("design:type", core_1.QueryList)
    ], MultilingualComponent.prototype, "inputs", void 0);
    __decorate([
        core_1.ViewChild('ngTextarea'),
        __metadata("design:type", core_1.ElementRef)
    ], MultilingualComponent.prototype, "ngTextarea", void 0);
    MultilingualComponent = __decorate([
        __param(0, core_1.Optional()),
        __metadata("design:paramtypes", [controls_translation_service_1.ControlsTranslationService,
            core_1.ChangeDetectorRef])
    ], MultilingualComponent);
    return MultilingualComponent;
}(sis_control_with_settings_base_1.SisControlWithSettingsBase));
exports.MultilingualComponent = MultilingualComponent;
//# sourceMappingURL=sis-multilingual.component.js.map